import React, { useState } from 'react'
import HOC from '../../components/HOC/HOC'


import { LiaArrowLeftSolid } from "react-icons/lia";
import { useNavigate } from 'react-router-dom';
import endPoints from '../../Repository/apiConfig';
import { postApi } from '../../Repository/Api';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AddPlan = () => {
    const navigate = useNavigate()
    const [name, setName] = useState('')
    const [type, setType] = useState('');
    const [price, setPrice] = useState(0);
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState('');

    const handleSubmit = async () => {
        const payload = {
            name: name,
            type: type,
            price: price,
            description: description
        }

        await postApi(endPoints.addSubscription, payload, {
            setLoading,
            successMsg: 'Subscription added successfully!',
            errorMsg: 'Failed to add subscription!',
        });
        navigate("/monthlysubscription");
    };

    const fullToolbarOptions = [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["clean"],
    ];

    return (
        <>
            <div className='userprofilecontainer'>
                <div className='partnerprofile-container'>
                    <div className='userprofile-header'>
                        <LiaArrowLeftSolid color='#000000' size={25} onClick={() => navigate(-1)} />
                        <h6>Add Plan</h6>
                    </div>
                    <div className='addserivce-btn'>
                        <button onClick={handleSubmit} disabled={loading}>
                            {loading ? "Saving..." : "Save"}
                        </button>
                    </div>
                </div>
                <div className='addsubcategory-left-div' style={{marginTop:"1rem"}}> 
                    <div className='addservice-left-div'>
                        <label htmlFor="">Subscription Plan</label>
                        <input
                            type="text"
                            placeholder='Plan Name'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    <div className='addservice-left-div'>
                        <label htmlFor="">Price</label>
                        <input
                            type="number"
                            placeholder='Enter Price'
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                        />
                    </div>
                    <div className='addservice-left-div'>
                        <label htmlFor="">Plan Duration</label>
                        <select name="" id=""
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        >
                            <option value="">Choose</option>
                            <option value="Week">Week</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Yearly">Yearly</option>
                        </select>
                    </div>
                </div>
                <div className='addservice-left-div'>
                    <label htmlFor="">Description</label>
                    <div className="custom-quill-wrapper">
                        <ReactQuill
                            theme="snow"
                            modules={{ toolbar: fullToolbarOptions }}
                            value={description}
                            onChange={setDescription}
                            className="custom-quill-editor"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default HOC(AddPlan)